/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValidityTime } from './validityTime';


/**
 * Validity update of granted permissions. Exactly one of validity and validityPeriod must be given; all permissions get the same validity time.
 */
export interface PermissionValidityUpdate { 
    /**
     * Granted permission internal IDs
     */
    permissionIds: Array<string>;
    validity?: ValidityTime;
    /**
     * Validity length (ISO 8601 duration, for example P2Y). Validity starts at the time of the update.
     */
    validityPeriod?: string;
}

